module.exports = __webpack_public_path__ + "44e1c3b2b9f69a4d4560fd211ed5ed46.png";